import { ModelRepositoryAdapter } from '../../../model-repository/model-repository-adapter'
import { ModelRepository } from '../../../model-repository/model-repository'

import { Observable } from 'rxjs/Observable'

import { QuestionContext } from '../../models'

const DEFAULT_RELATIONSHIPS = ['questionContextType']

export class QuestionContextService extends ModelRepositoryAdapter<QuestionContext> {
  public constructor(private _modelRepository: ModelRepository) {
    super(_modelRepository, QuestionContext)
  }

  public findModelByIdWithRelationships(id: string): Observable<QuestionContext> {
    return this.findModelById(id, DEFAULT_RELATIONSHIPS)
  }

  public findAllModelsWithRelationships(): Observable<QuestionContext[]> {
    return this.findAllModels(DEFAULT_RELATIONSHIPS)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/services/question-context/question-context.service.ts